(function(root, unasigned) {
  root.md.diagnosis = root.md.diagnosis || {};
  var ns = root.md.diagnosis.diagnosis = root.md.diagnosis.diagnosis || {};
  
  // ControlDisplay
  ns.Display = function($section){
    this.Evt = $({});
    this.$section = $section;
    this.$submitBtn = $(".js-btn-submit");
    this.ERROR_CLASS_NAME_LIST = ["error-blank", "error-min", "error-max", "error-over-savings", "error-lower-minimum-investment"];
    this.INPUT_SELECTOR = ".js-story-input, .js-story-select";
  };
  
  ns.Display.prototype.init = function(){
    this.hideHintAll();
    
    this.$focusBg = $("<div></div>").addClass("bg-focus").appendTo(".wrapper");
  };
  ns.Display.prototype.showError = function(index, id){
    var selector = (id || id === 0) ? (".story-error." + this.ERROR_CLASS_NAME_LIST[id]) : ".story-error";
    var $targetSection = this.$section.eq(index);
    $targetSection.find(selector).stop(true, true).delay(100).slideDown(300);
    $targetSection.find(this.INPUT_SELECTOR).addClass("error");
  };
  ns.Display.prototype.hideError = function(index, id){
    var selector = (id || id === 0) ? (".story-error:not(." + this.ERROR_CLASS_NAME_LIST[id] + ")") : ".story-error";
    var $targetSection = this.$section.eq(index);
    $targetSection.find(selector).stop(true, true).delay(100).slideUp(300);
    $targetSection.find(this.INPUT_SELECTOR).removeClass("error");
  };
  ns.Display.prototype.showHint = function(index){
    var age = $("#diagnosisAnswer1").val();
    var savings =$("#savings").val();
    var income =$("#income").val();

    var arrayDataByAge = [
        ["10代","22万円",35.4],
        ["20代","22万円",35.4],
        ["30代","33万円",34.6],
        ["40代","42万円",30.2],
        ["50代","54万円",28.0],
        ["60代","70万円",10.4],
        ["70歳以上","40万円",19.2],
        ["-","-万円",0]
    ];
    var indexOfAge;
    if (age >= 18 && age <= 19) {
      indexOfAge = 0;
    }
    else if (age >= 20 && age <= 29) {
      indexOfAge = 1;
    }
    else if (age >= 30 && age <= 39) {
      indexOfAge = 2;
    }
    else if (age >= 40 && age <= 49) {
      indexOfAge = 3;
    }
    else if (age >= 50 && age <= 59) {
      indexOfAge = 4;
    }
    else if (age >= 60 && age <= 69) {
      indexOfAge = 5;
    }
    else if (age >= 70 && age <= 120) {
      indexOfAge = 6;
    }
    else {
      indexOfAge = 7;
    }
    var arrayDataOfTaxByIncome = [
        ["~114万円",10],
        ["115万円~430万円",15],
        ["431万円~634万円",20],
        ["635万円~1,076万円",30],
        ["1,077万円~1,299万円",33],
        ["1,300万円~2,250万円",43],
        ["2,251万円~4,575万円",50],
        ["4,576万円~",55],
        ["-",0]
    ];
    var indexOfIncome;
    if (income >= 1 && income <= 114) {
        indexOfIncome = 0;
    }
    else if (income >= 115 && income <= 430) {
        indexOfIncome = 1;
    }
    else if (income >= 431 && income <= 634) {
        indexOfIncome = 2;
    }
    else if (income >= 635 && income <= 1076) {
        indexOfIncome = 3;
    }
    else if (income >= 1077 && income <= 1299) {
        indexOfIncome = 4;
    }
    else if (income >= 1300 && income <= 2250) {
        indexOfIncome = 5;
    }
    else if (income >= 2251 && income <= 4575) {
        indexOfIncome = 6;
    }
    else if (income >= 4576) {
        indexOfIncome = 7;
    }
    else {
        indexOfIncome = 8;
    }

    var ageRange = arrayDataByAge[indexOfAge][0];
    var theoAverageStartInvestment = arrayDataByAge[indexOfAge][1];
    var averageSavingsRatio = arrayDataByAge[indexOfAge][2];
    var averageSavings = income * 10000 * (100 - arrayDataOfTaxByIncome[indexOfIncome][1])/100 * averageSavingsRatio/100 / 12;
    averageSavings = Math.floor(averageSavings/10000);
    averageSavingsRatio = averageSavingsRatio + "%";
    averageSavings = averageSavings.toLocaleString() + "万円";

    $(".age-range").text(ageRange);
    $(".theo-average-start-investment").text(theoAverageStartInvestment);
    $(".average-savings-ratio").text(averageSavingsRatio);
    $(".average-savings").text(averageSavings);

    this.$section.eq(index).find(".story-hint")
    // .css("height", "")
    .css("position", "")
    .animate({
      opacity: 1,
    },{
      step: function(now){
        $(this).css({
          // "transform": "translateY(" + (100 - now * 100) + "%)",
        });
      },
    });
  };
  ns.Display.prototype.hideHint = function(index){
    this.$section.eq(index).find(".story-hint")
    .css("position", "absolute")
    .animate({
      opacity: 0,
      // height: 0,
    },{
      duration: 300,
      complete: function(){
        $(this).css({
          // "transform": "translateY(100%)",
        });
      },
    });
  };
  ns.Display.prototype.hideHintAll = function(index){
    var that = this;
    this.$section.each(function(i){
      if (i === index) return true;
      that.hideHint(i);
    });
  };
  ns.Display.prototype.showFocusBg = function(index){
    // this.$focusBg.fadeIn();
  };
  ns.Display.prototype.hideFocusBg = function(index){
    this.$focusBg.fadeOut();
  };
  ns.Display.prototype.focusSection = function(index){
    this.hideHintAll(index);
    this.$section.eq(index).addClass("focus");
  };
  ns.Display.prototype.blurSection = function(index){
    this.$section.eq(index).removeClass("focus");
  };
  ns.Display.prototype.blurSectionAll = function(){
    this.$section.removeClass("focus");
  };
  ns.Display.prototype.showSection = function(index){
    var that = this;
    this.blurSectionAll();
    this.focusSection(index);
    // this.Evt.on("shown.bs.collapse", function(){
    //   that.Evt.trigger("showend", that.$section.eq(index));
    // });
    // return this.$section.eq(index).collapse("show");
    this.$section.eq(index).fadeIn({
      complete: function(){
        that.Evt.trigger("showend", this);
      },
    });
  };
  ns.Display.prototype.hideSection = function(index){
    // this.$section.eq(index).collapse("hide");
    this.$section.eq(index).fadeOut();
  };
  ns.Display.prototype.isShownSection = function(index){
    return this.$section.eq(index).is(":visible");
  };
  ns.Display.prototype.isLatestSection = function(index){
    return index === this.getLatestSectionIndex();
  };
  ns.Display.prototype.getLatestSectionIndex = function(){
    return this.$section.filter(":visible").length - 1;
  };
  ns.Display.prototype.showSubmitBtn = function(){
    this.hideHintAll();
    this.$submitBtn.collapse("show");
  };
  ns.Display.prototype.enableSubmitBtn = function(){
    this.$submitBtn.removeClass("btn-disable");
  };
  ns.Display.prototype.disableSubmitBtn = function(){
    this.$submitBtn.addClass("btn-disable");
  };
  
})(this);
